import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal. `lines` is an array of strings (or nodes).
export function MaskedHeading({ lines, className = "", delay = 0, stagger = 0.12 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: easing, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
